import { ACTION_TYPES } from "../actions/loading";
import { initialState } from "./initialState";

export const loading = (state = initialState.loading, action) => {
    const { type } = action;
    const matches = /(.*)_(REQUEST|SUCCESS|FAILURE)/.exec(type);
    if (type === ACTION_TYPES.API_CALL_BEGIN) {
        return state + 1;
    } else if (matches) {
        if (state === 0) {
            return state
        }

        return state - 1;
    }

    return state;
}